import { useMemo } from "react";
import { day as Props } from "../../../types/calendar";
import differenceInDays from "date-fns/differenceInDays";
import Favorite from "../../../svg/Favorite";
import startOfDay from "date-fns/startOfDay";
import { Day, DisabledDay, WinDay } from "./DataCell.components";

const DataCell: React.FC<Props> = ({ day, thisMonthNow, selectedDay, setSelectedDay }) => {
  const indexDay = differenceInDays(new Date(day.fullDate), startOfDay(new Date()));

  const isToday = useMemo(() => selectedDay === day.fullDate.toString(), [day.fullDate, selectedDay]);
  const handleSelectDay = () => setSelectedDay(day.fullDate.toString());

  if (day.month !== thisMonthNow) {
    return;
  }

  if (day.isWon) {
    return (
      <WinDay onClick={handleSelectDay} isToday={isToday}>
        <Favorite />
      </WinDay>
    );
  }

  if (day.month === thisMonthNow && indexDay <= 0) {
    return (
      <Day onClick={handleSelectDay} isToday={isToday}>
        {day.date}
      </Day>
    );
  }

  return <DisabledDay day={day.date} />;
};

export default DataCell;
